import React, { useEffect } from 'react'
import './App.scss';
import RouteComponent from "./routes/route"
import { RootState } from './store/reducers';
import Alert from './components/Alert';
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../src/store";
import {
  useNavigate,
  useLocation
} from "react-router-dom";
import i18n from './i18n'
import { getCookie } from "../src/helper/cookieFunction";
import FreezScreen from './components/FreezScreen';


export default function App() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const state = useSelector((state: RootState) => state.waiter);
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);




  useEffect(() => {
    const onLanguageHandle = () => {
      i18n.changeLanguage(state.langValue);
      localStorage.setItem("Language", JSON.stringify(state.langValue));
    };
    onLanguageHandle();
  }, [state.langValue]);

  return (
    <div  className={` App ${state.langValue === "ar" ? "directionRtl" : ""}`}>
      {state.freezScreen && <FreezScreen /> }
      {state.alert.show && <Alert />}
      <RouteComponent />
    </div>
  );
}
